import { useState } from "react";
import styles from "../styles/_components/mainCard.module.scss";

const MainCard = ({ visitors, setVisitors, cart, setCart }) => {
  const [isOpen, setIsOpen] = useState();

  return (
    <div className={styles.container}>
      {/* ==== RIGHT SECTION ==== */}
      <div className={styles.right}>
        <div
          className={styles.imgWrapper}
          style={{ backgroundImage: "url('/assets/mainCardPic.jpg')" }}
        />
      </div>

      {/* ==== MIDDLE SECTION ==== */}
      <div className={styles.middle}>
        <h1>Entrance fees to the Ben-Gurion barracks site</h1>
        <p>
          The site of the Ben-Gurion Barracks, the home of Paula and David
          Ben-Gurion is open to the public. In addition, the website has a
          variety of exhibitions and displays for adults and children. Please
          note, it is not possible to register for a visit to the barracks on
          Friday-Saturday on this page, you must register on the "Request a
          visit" page on the Ben-Gurion barracks website.
        </p>
        <div className={styles.schedule}>
          <p>
            {/* activity time */}
            Hours of operation: {/* timings */}
            <b>Tuesday from 09:00 to 16:00</b>
          </p>
        </div>
      </div>

      {/* ==== LEFT SECTION ==== */}
      <div className={styles.left}>
        {/* == DATE SELECTION == */}
        <div className={styles.dateSelection}>
          {isOpen === 1 ? (
            <img src="/assets/upIcon.svg" className={styles.chevron} />
          ) : (
            <img src="/assets/downIcon.svg" className={styles.chevron} />
          )}
          <select
            name="dateSelection"
            onClick={() => {
              if (isOpen === 1) {
                setIsOpen(null);
              } else {
                setIsOpen(1);
              }
            }}
            onBlur={() => setIsOpen(null)}
          >
            <option value="Date selection" selected disabled>
              Date selection
            </option>
            <option value="20/12/2022 - Tuesday">20/12/2022 - Tuesday</option>
            <option value="20/12/2022 - Tuesday">20/12/2022 - Tuesday</option>
            <option value="20/12/2022 - Tuesday">20/12/2022 - Tuesday</option>
            <option value="20/12/2022 - Tuesday">20/12/2022 - Tuesday</option>
          </select>
        </div>

        {/* == TIME SELECTION == */}
        <div className={styles.timeSelection}>
          {isOpen === 2 ? (
            <img src="/assets/upIcon.svg" className={styles.chevron} />
          ) : (
            <img src="/assets/downIcon.svg" className={styles.chevron} />
          )}
          <select
            name="timeSelection"
            onClick={() => {
              if (isOpen === 2) {
                setIsOpen(null);
              } else {
                setIsOpen(2);
              }
            }}
            onBlur={() => setIsOpen(null)}
          >
            <option value="Choose a time" selected disabled>
              Choose a time
            </option>
            <option value="Arrival at 15:00 Stock - 120 tickets">
              Arrival at 15:00 Stock - 120 tickets
            </option>
            <option value="Arrival at 15:00 Stock - 120 tickets">
              Arrival at 15:00 Stock - 120 tickets
            </option>
            <option value="Arrival at 15:00 Stock - 120 tickets">
              Arrival at 15:00 Stock - 120 tickets
            </option>
            <option value="Arrival at 15:00 Stock - 120 tickets">
              Arrival at 15:00 Stock - 120 tickets
            </option>
          </select>
        </div>

        {/* == PEOPLE CATEGORY == */}
        <div className={styles.typesOfPeople}>
          {visitors.map((i) => (
            <div className={styles.row} key={i.id}>
              <p className={styles.name}>{i.title}</p>
              <p className={styles.price}>${i.price}</p>
              <div className={styles.counter}>
                <button
                  onClick={() => {
                    setVisitors((prev) =>
                      prev.map((x) => {
                        if (x.id === i.id)
                          return {
                            ...x,
                            amount:
                              Number(x.amount) > 0
                                ? Number(x.amount) - Number(x.price)
                                : 0,
                          };
                        return x;
                      })
                    );
                  }}
                >
                  -
                </button>
                <input type="number" value={i.amount} />
                <button
                  onClick={() => {
                    setVisitors((prev) =>
                      prev.map((x) => {
                        if (x.id === i.id)
                          return {
                            ...x,
                            amount: Number(x.amount) + Number(x.price),
                          };
                        return x;
                      })
                    );
                  }}
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* == TOTAL == */}
        <div className={styles.total}>
          <p>Total ticket cost:</p>
          <h3>
            $
            {visitors.reduce(
              (accumulator, current) => accumulator + current.amount,
              0
            )}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default MainCard;
